/*
© Copyright 2021 Orolabs.ai to present
* All rights reserved.
* Unauthorized copying of this file, via any medium is strictly prohibited.
* Proprietary and confidential.
* Author:
*/

import type { SVGProps } from 'react'

/**
 * `arrow-narrow-up-right` (Untitled UI). Exact glyph pulled from the Figma
 * subrequest badge (node `2739:84891`); the stroke path is authored in a
 * 9.333-unit box and centered inside a 16-unit viewBox to preserve the
 * ~20.83% inset the design applies inside its 16 px icon slot.
 */
export default function ArrowUpRight(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      {...props}
      fill="none"
    >
      <g transform="translate(3.333333 3.333333)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.66667 0.666667C2.66667 0.298477 2.96514 0 3.33333 0H8.66667C9.03486 0 9.33333 0.298477 9.33333 0.666667V6C9.33333 6.36819 9.03486 6.66667 8.66667 6.66667C8.29848 6.66667 8 6.36819 8 6V2.27614L1.13807 9.13807C0.877722 9.39842 0.455612 9.39842 0.195262 9.13807C-0.0650874 8.87772 -0.0650874 8.45561 0.195262 8.19526L7.05719 1.33333H3.33333C2.96514 1.33333 2.66667 1.03486 2.66667 0.666667Z"
          fill={props.fill || 'currentColor'}
        />
      </g>
    </svg>
  )
}
